/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Img from '../../Img';
import PrismicLink from '../../Links/PrismicLink';
// import config from '../../../../config';

// const { marketingAppHost } = config;

// eslint-disable-next-line react/prefer-stateless-function
class FeaturedPromoCard extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);

        // this.onClick = this.onClick.bind(this);
        // this.prismicRedirect = this.prismicRedirect.bind(this);
    }

    // onClick() {
    //     const ctaLink = this.props.content.cta_link;
    //     this.prismicRedirect(ctaLink);
    // }

    // prismicRedirect(link) {
    //     if (link.startsWith('http')) {
    //         // external urls, like support page
    //         const win = window.open(link, '_blank');
    //         win.focus();
    //     } else if (link.startsWith('app:')) {
    //         // internal routing within utr app
    //         this.props.history.push(link.replace('app:', ''));
    //     } else {
    //         window.location = `${marketingAppHost}${link}`;
    //     }
    // }

    render() {
        const { title, description, image, cta_copy, cta_link, overlay_percent } = this.props.content;
        const { 'data-testid': dataTestId } = this.props;
        // const desktopBg = image && image.desktop;
        const mobileBg = image && image.mobile;

        const bgImg = (imageObj) => {
            if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
                return (
                    <Img
                        useRawSrcSet={true}
                        src={imageObj.oneX}
                        srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
                        style={{ left: '0%' }}
                    />
                );
            } if (imageObj && imageObj.default) {
                return (
                    <Img
                        src={imageObj.default}
                        style={{ left: '0%' }}
                    />
                );
            }
            return null;
        };

        let backGroundImage = 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)';
        if (overlay_percent) {
            if (typeof overlay_percent === 'string' || typeof overlay_percent === 'number') {
                backGroundImage = `linear-gradient(to bottom, rgba(0, 0, 0, 0.${overlay_percent}) 0%, rgba(0, 0, 0, 0.${overlay_percent}) 100%)`;
            }
        }

        return (
            <div className={`utr-card featured-promo-card has-background-image`}>
                <div className={`backgroundWrapper`}>
                    <picture>
                        {bgImg(mobileBg)}
                    </picture>
                    <div
                        className={`card-view`}
                        style={{
                            backgroundImage: backGroundImage,
                        }}
                    >
                        <div className={`content`}>
                            <div className={`name show-ellipsis text-white`} data-testid={dataTestId && `${dataTestId}.name`}>
                                {title}
                            </div>
                            <div className={`description text-white`} dangerouslySetInnerHTML={{ __html: description }} data-testid={dataTestId && `${dataTestId}.description`} />
                            {cta_copy && cta_link && (
                                <div className="cta mt-auto">
                                    <PrismicLink link={cta_link}>
                                        <div className="btn btn-sm btn-primary btn-lg text-white text-uppercase" data-testid={dataTestId && `${dataTestId}.cta-btn`}>{cta_copy}</div>
                                    </PrismicLink>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

FeaturedPromoCard.defaultProps = {
    'data-testid': null,
};

export default withRouter(FeaturedPromoCard);
